<template>
  <div class="block-heading" :class="headingType">
    <div class="placeholder" v-html="htmlText"></div>
    <textarea :value="modelValue" v-on:input="$emit('update:modelValue', $event.target.value)" v-on:keydown="keyDown"></textarea>
  </div>
</template>
<script>
export default {
  props: ["headingType", "modelValue"],
  mounted() {
  
  },
  computed: {
    htmlText() {
      var text=String(this.modelValue || "");
      text=text.replace(/\n/g, "<br />\n");
      text=text.replace(/\</g, "&lt;");
      text=text.replace(/\>/g, "&gt;");
      text=text.replace(/"</g, "&quot;");
      text=text.replace(/\&/g, "&amp;");
      return text;
    }
  },
  methods: {
    keyDown($e) {
      if ($e.keyCode==13) {
        $e.preventDefault();
        this.$emit("new-block", {});
      }
    },
  },
}
</script>
